import { inject } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ActivatedRouteSnapshot, ResolveFn, Routes } from '@angular/router';
import UserRouteAccessService from 'app/core/auth/user-route-access-service';
import {
  Observable, of
} from 'rxjs';
import {
  filter, map
} from 'rxjs/operators';
import {
  CardInfoRx, ICardInfoRx
} from 'app/shared/model/card-info-rx.model';
import CardInfoRxService from './card-info-rx.service';
import CardInfoRxComponent from './card-info-rx.component';
import CardInfoRxUpdateComponent from './card-info-rx-update.component';
import ResolvePagingParams from '../resolve-paging-params.service';

export const CardInfoRxResolve: ResolveFn<ICardInfoRx> = (route: ActivatedRouteSnapshot): Observable<ICardInfoRx> => {
  const { id } = route.params;
  if (id) {
    return inject(CardInfoRxService).find(id).pipe(
      filter((response: HttpResponse<CardInfoRx>) => response.ok),
      map((cardInfo: HttpResponse<CardInfoRx>) => cardInfo.body)
    );
  }
  return of(new CardInfoRx());
};

export const cardInfoRoute: Routes = [
  {
    path: '',
    component: CardInfoRxComponent,
    resolve: {
      pagingParams: ResolvePagingParams
    },
    data: {
      authorities: ['ROLE_USER'],
      defaultSort: 'id,asc',
      pageTitle: 'bjcrxApp.cardInfo.home.title'
    },
    canActivate: [UserRouteAccessService]
  },
  {
    path: 'new/:id',
    component: CardInfoRxUpdateComponent,
    data: {
      authorities: ['ROLE_USER'],
      pageTitle: 'bjcrxApp.cardInfo.home.title'
    },
    canActivate: [UserRouteAccessService]
  },
  {
    path: ':id/update',
    component: CardInfoRxUpdateComponent,
    data: {
      authorities: ['ROLE_USER'],
      pageTitle: 'bjcrxApp.cardInfo.home.title'
    },
    canActivate: [UserRouteAccessService]
  },
  {
    path: ':id/edit',
    component: CardInfoRxUpdateComponent,
    resolve: {
      cardInfo: CardInfoRxResolve
    },
    data: {
      authorities: ['ROLE_USER'],
      pageTitle: 'bjcrxApp.cardInfo.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];
